import { financialRouter } from "./financialRouter";
import { orderRouter } from "./orderRouter";

export const userRouter = [
  {
    path: "/control",
    name: "control",
    component: resolve => require(["@/page/control/control"], resolve),
    children: [

      // 概览
      {
        path: "/glCenter",
        name: "glCenter",
        meta : {
          title: "GPUEZ智算云 - 概览",
          pagetitle: "概览"
        },
        component: resolve => require(["@/page/control/slCenter/home/homeView"], resolve),
        children: [
          // GPUEZ智算云 - 概览中心
          {
            path: "/glCenter/home",
            name: "home",
            meta : {
              title: "GPUEZ智算云 - 概览中心",
              pagetitle: "概览中心"
            },
            component: resolve => require(["@/page/control/slCenter/home/index"], resolve),
          },
          // 概览 - 成长值
          {
            path: "/glCenter/glGrowth",
            name: "glGrowth",
            meta : {
              title: "GPUEZ智算云 - 成长值",
              pagetitle: "成长值"
            },
            component: resolve => require(["@/page/control/slCenter/home/growthValue"], resolve),
          },
          // 概览 - 算力豆明细
          {
            path: "/glCenter/giftDetail",
            name: "giftDetail",
            meta : {
              title: "GPUEZ智算云 - 算力豆明细",
              pagetitle: "算力豆明细"
            },
            component: resolve => require(["@/page/control/slCenter/home/giftDetail"], resolve),
          },
          // 概览 - 发送记录
          {
            path: "/glCenter/glRecord",
            name: "glRecord",
            meta : {
              title: "GPUEZ智算云 - 发送记录",
              pagetitle: "发送记录"
            },
            component: resolve => require(["@/page/control/slCenter/home/sendRecord"], resolve),
          },
        ],
        redirect: "/glCenter/home"
      },
      // 算力
      {
        path: "/slCenter",
        name: "slCenter",
        meta : {
          title: "GPUEZ智算云 - 算力中心"
        },
        component: resolve => require(["@/page/control/slCenter/slCenter"], resolve),
        children: [
          {
            path: "/slCenter/home",
            name: "slHome",
            meta : {
              title: "GPUEZ智算云 - 算力中心 - 概览",
              pagetitle: "概览"
            },
            component: resolve => require(["@/page/control/slCenter/home/index"], resolve),
          },
          {
            path: "/slCenter/sendRecord",
            name: "sendRecord",
            meta : {
              title: "GPUEZ智算云 - 算力中心 - 发送记录",
              pagetitle: "发送记录"
            },
            component: resolve => require(["@/page/control/slCenter/home/sendRecord"], resolve),
          },
          {
            path: "/slCenter/growthValue",
            name: "growthValue",
            meta : {
              title: "GPUEZ智算云 - 算力中心 - 成长值",
              pagetitle: "成长值"
            },
            component: resolve => require(["@/page/control/slCenter/home/growthValue"], resolve),
          },
          {
            path: "/slCenter/monitor",
            name: "monitor",
            meta : {
              title: "GPUEZ智算云 - 算力中心 - 实例监控",
              pagetitle: "实例监控"
            },
            component: resolve => require(["@/page/control/slCenter/monitor/index"], resolve),
          },
          {
            path: "/slCenter/container",
            name: "slcontainer",
            meta : {
              title: "GPUEZ智算云 - 算力中心 - 容器实例",
              pagetitle: "容器实例"
            },
            component: resolve => require(["@/page/control/slCenter/container/container"], resolve),
            children: [
              {
                path: "/slCenter/container/base",
                name: "baseContainer",
                meta : {
                  title: "GPUEZ智算云 - 算力中心 - 基础实例",
                  pagetitle: "基础实例"
                },
                component: resolve => require(["@/page/control/slCenter/container/index"], resolve),
              },
              {
                path: "/slCenter/container/apply",
                name: "applyContainer",
                meta : {
                  title: "GPUEZ智算云 - 算力中心 - 应用实例",
                  pagetitle: "应用实例"
                },
                component: resolve => require(["@/page/control/slCenter/apply/index"], resolve),
              },
            ],
            redirect: "/slCenter/container/base"
          },
          {
            path: "/slCenter/mirror",
            name: "slMirror",
            meta : {
              title: "GPUEZ智算云 - 算力中心 - 镜像",
              pagetitle: "镜像"
            },
            component: resolve => require(["@/page/control/slCenter/mirror/index"], resolve),
          },
          {
            path: "/slCenter/myHost",
            name: "myHost",
            meta : {
              title: "GPUEZ智算云 - 算力中心 - 我的主机",
              pagetitle: "我的主机"
            },
            component: resolve => require(["@/page/control/slCenter/myHost/myHost"], resolve),
          },
          {
            path: "/slCenter/nakedHost",
            name: "nakedHost",
            meta : {
              title: "GPUEZ智算云 - 算力中心 - 裸金属",
              pagetitle: "裸金属"
            },
            component: resolve => require(["@/page/control/slCenter/myHost/nakedHost"], resolve),
          },
          {
            path: "/slCenter/myHost/containers",
            name: "hostSlContainer",
            meta : {
              title: "GPUEZ智算云 - 算力中心 - 我的主机",
              pagetitle: "我的主机"
            },
            component: resolve => require(["@/page/control/slCenter/myHost/containers"], resolve),
          },
          {
            path: "/slCenter/opendata",
            name: "slOpendata",
            meta : {
              title: "GPUEZ智算云 - 算力中心 - 公开数据",
              pagetitle: "公开数据"
            },
            component: resolve => require(["@/page/control/slCenter/opendata/index"], resolve),
          },
          {
            path: "/slCenter/filesave",
            name: "filesave",
            meta : {
              title: "GPUEZ智算云 - 算力中心 - 我的云盘",
              pagetitle: "我的云盘"
            },
            component: resolve => require(["@/page/control/slCenter/filesave/index"], resolve),
          },
        ],
        redirect: "/slCenter/container"
      },
      // 存储
      {
        path: "/cloudStore",
        name: "cloudStore",
        meta : {
          title: "GPUEZ智算云 - 云存储"
        },
        component: resolve => require(["@/page/control/cloudStore/cloudStore"], resolve),
        children: [
          {
            path: "/cloudStore/spaceStore",
            name: "spaceIndex",
            meta : {
              title: "GPUEZ智算云 - 空间存储"
            },
            component: resolve => require(["@/page/control/cloudStore/spaceStore/spaceIndex"], resolve),
          },

          {
            path: "/cloudStore/spaceHome",
            name: "spaceHome",
            meta : {
              title: "GPUEZ智算云 - 空间存储"
            },
            component: resolve => require(["@/page/control/cloudStore/spaceStore/spaceHome"], resolve),
            children: [
              {
                path: "/cloudStore/spaceView",
                name: "spaceView",
                meta : { title: "GPUEZ智算云 - 空间存储" },
                component: resolve => require(["@/page/control/cloudStore/spaceStore/spaceView/spaceView"], resolve),
              },
              {
                path: "/cloudStore/fileManage",
                name: "fileManage",
                meta : { title: "GPUEZ智算云 - 文件管理" },
                component: resolve => require(["@/page/control/cloudStore/spaceStore/fileManage/fileManage"], resolve),
              },
              {
                path: "/cloudStore/imgEdit",
                name: "imgEdit",
                meta : { title: "GPUEZ智算云 - 图片样式" },
                component: resolve => require(["@/page/control/cloudStore/spaceStore/imgEdit/imgEdit"], resolve),
              },
              {
                path: "/cloudStore/transCode",
                name: "transCode",
                meta : { title: "GPUEZ智算云 - 转码样式" },
                component: resolve => require(["@/page/control/cloudStore/spaceStore/transCode/transCode"], resolve),
              },
            ]
          },
          

          {
            path: "/cloudStoreInfo",
            name: "cloudStoreInfo",
            meta : {
              title: "GPUEZ智算云 - 云存储"
            },
            component: resolve => require(["@/page/control/userPage/cloudStoreInfo/cloudStoreInfo"], resolve),
          },
        ],
        redirect: "/cloudStore/spaceStore"
      },
      // 社区
      {
        path: "/community",
        name: "community",
        meta : {
          title: "GPUEZ智算云 - 卡券",
        },
        // component: resolve => require(["@/page/control/userPage/systemTicket/systemTicket"], resolve),
      },
      // 财务
      {
        path: "/financial",
        name: "financial",
        component: resolve => require(["@/page/control/financial/financial"], resolve),
        children: [
          ...financialRouter,
          ...orderRouter,
        ],
        redirect: "/financial/overview"
      },
      // 卡券
      {
        path: "/systemTicket",
        name: "systemTicket",
        meta : {
          title: "GPUEZ智算云 - 卡券",
        },
        component: resolve => require(["@/page/control/userPage/systemTicket/systemTicket"], resolve),
      },
      // 我的
      {
        path: "/userPage",
        name: "userPage",
        meta : {
          title: "GPUEZ智算云 - 个人中心"
        },
        component: resolve => require(["@/page/control/userPage/userPage"], resolve),
        children: [
          {
            path: "/userPage/userInfo",
            name: "userInfo",
            meta : {
              title: "GPUEZ智算云 - 个人信息",
              pagetitle: "个人信息"
            },
            component: resolve => require(["@/page/control/userPage/userInfo/userInfo"], resolve),
          },
          {
            path: "/userPage/keyManage",
            name: "keyManage",
            meta : {
              title: "GPUEZ智算云 - 密钥管理",
              pagetitle: "密钥管理"
            },
            component: resolve => require(["@/page/control/userPage/keyManage/keyManage"], resolve),
          },
          {
            path: "/userPage/safetySet",
            name: "safetySet",
            meta : {
              title: "GPUEZ智算云 - 安全设置",
              pagetitle: "安全设置"
            },
            component: resolve => require(["@/page/control/userPage/safetySet/safetySet"], resolve),
          },
          {
            path: "/userPage/identityCheck",
            name: "identityCheck",
            meta : {
              title: "GPUEZ智算云 - 实名认证",
              pagetitle: "实名认证"
            },
            component: resolve => require(["@/page/control/userPage/identityCheck/identityCheck"], resolve),
          },
          {
            path: "/userPage/accountManagement",
            name: "accountManagement",
            meta : {
              title: "GPUEZ智算云 - 账号管理",
              pagetitle: "账号管理"
            },
            component: resolve => require(["@/page/control/userPage/accountManagement/accountManagement"], resolve),
          },
        ],
        redirect: "/userPage/userInfo"
      },

      // 牛马小强
      {
        path: "/chat",
        name: "chat",
        meta : {
          title: "智算云 - 牛马小强"
        },
        component: resolve => require(["@/page/control/chat/chat"], resolve),
        children: [
          {
            path: "/chat/hot",
            name: "chatHot",
            meta : {
              title: "牛马小强 - 时事热点",
              pagetitle: "时事热点"
            },
            component: resolve => require(["@/page/control/chat/hot/hot"], resolve),
          },
          {
            path: "/chat/create",
            name: "chatCreate",
            meta : {
              title: "牛马小强 - 在线创作",
              pagetitle: "在线创作"
            },
            component: resolve => require(["@/page/control/chat/create/create"], resolve),
          },
          {
            path: "/chat/log",
            name: "chatlog",
            meta : {
              title: "牛马小强 - 创作记录",
              pagetitle: "创作记录"
            },
            component: resolve => require(["@/page/control/chat/log/log"], resolve),
          },
        ],
        redirect: "/chat/hot"
      },

      // 推广
      {
        path: "/tkMotion",
        name: "tkMotion",
        meta : {
          title: "GPUEZ智算云 - 推广大使",
          pagetitle: "推广大使"
        },
        component: resolve => require(["@/page/control/slCenter/promotion/promotion"], resolve),
      },
      // 消息
      {
        path: "/systemMsg",
        name: "systemMsg",
        meta : {
          title: "GPUEZ智算云 - 系统消息",
        },
        component: resolve => require(["@/page/control/userPage/systemMsg/systemMsg"], resolve),
      },
      // 工单
      {
        path: "/workOrder",
        name: "workOrder",
        component: resolve => require(["@/page/control/workOrder/workOrder"], resolve),
        children: [
          {
            path: "/workOrder/generalSituation",
            name: "generalSituation",
            meta : {
              title: "GPUEZ智算云 - 工单概况",
              pagetitle: "工单概况"
            },
            component: resolve => require(["@/page/control/workOrder/generalSituation/generalSituation"], resolve),
          },
          {
            path: "/workOrder/workOrderDetails",
            name: "workOrderDetails",
            meta : {
              title: "GPUEZ智算云 - 工单详情",
              pagetitle: "工单详情"
            },
            component: resolve => require(["@/page/control/workOrder/workOrderDetails/workOrderDetails"], resolve),
          },
        ],
        redirect: "/workOrder/generalSituation"
      },

      // sylloCore
      {
        path: "/sylloCore",
        name: "sylloCore",
        meta : {
          title: "GPUEZ智算云 - SylloCore"
        },
        component: resolve => require(["@/page/control/sylloCore/sylloCore"], resolve),
      },

    ],
    redirect: "/userPage"
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/userRouter.js